angular.module('bmsApp.marketing').factory('CampaignSvc', function ($http, $log, $window, $q, CRUDSvc, CAMPAIGN_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(CAMPAIGN_API.INDEX, params);
		},
		read: function (params) {
			return CRUDSvc.read(CAMPAIGN_API.READ, params);
		},
		create: function (data) {
			return CRUDSvc.create(CAMPAIGN_API.CREATE, data);
		},
		update: function (data) {
			return CRUDSvc.update(CAMPAIGN_API.UPDATE, data.id, data);
		},
		options: function (params) {
			return CRUDSvc.get(CAMPAIGN_API.OPTIONS, params);
		}
	}

}).constant('CAMPAIGN_API', {
	INDEX: 'api/marketing/campaigns/index',
	READ: 'api/marketing/campaign/read',
	CREATE: 'api/marketing/campaign/create',
	UPDATE: 'api/marketing/campaign/update',
	OPTIONS: 'api/marketing/campaign/options'
});




